export const formatTimeout = (value: number): string =>
  `${'0'}:${value.toString().padStart(2, '0')}`;
